'use strict';

var GridToolbarSystemConfigurationAdvancedModalController = function GridToolbarSystemConfigurationAdvancedModalController($scope) {
  $scope.isGridEditable = $scope.jqxGridSettings.editable;
};
GridToolbarSystemConfigurationAdvancedModalController.$inject = ['$scope'];
module.exports = GridToolbarSystemConfigurationAdvancedModalController;